<p-table [value]="inrSet" [rows]="4" [tableStyleClass]="'inr-custom-table'" [loading]="loading" [paginator]="true"
  [showCurrentPageReport]="false" responsiveLayout="scroll" styleClass="p-datatable-sm" selectionMode="single"
  [(selection)]="selectedRequest" (onRowSelect)="onRowSelect($event)" dataKey="id">
  <ng-template pTemplate="header">
    <tr class="table-row">
      <th *ngFor="let col of columns" [style]="col?.style">
        {{col?.title}}</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-dataRow>
    <tr class="border-bottom hover-bg-light" [pSelectableRow]="dataRow">
      <td class="ps-3 py-1">
        <span class="d-block fw-bold text-dark">{{ dataRow.submissionDate | date : "dd/MM/yyyy" }}</span>
      </td>
      <td class="py-1 fw-bold text-dark">{{ dataRow.submittedValue }}</td>
      <td class="py-1 fw-bold text-dark">{{ dataRow.currentDose }} mg</td>
      <td class="py-1 text-center">
        <ng-container *ngIf="dataRow.attachments && dataRow.attachments.length > 0; else noAttachments">
          <a *ngFor="let attachment of dataRow.attachments"
            (click)="downloadAttachment(attachment, dataRow); $event.stopPropagation()" class="d-inline-block me-1"
            style="cursor: pointer;" [pTooltip]="attachment.fileName" tooltipPosition="top">
            <i class="pi pi-file fs-4 text-secondary"></i>
          </a>
        </ng-container>
        <ng-template #noAttachments>
          <span class="text-muted small">-</span>
        </ng-template>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td class="text-center text-muted py-4" [attr.colspan]="columns.length">No INR submissions found.</td>
    </tr>
  </ng-template>
</p-table>